module.exports = "/_next/static/media/462091455627833e59a277d121721a08.svg";